import { oc } from '@orpc/contract';
import { updateVehicleInputSchema, vehicleDetailSchema } from '../schemas/vehicles.schemas.js';
/**
 * PATCH semantics with `expectedRevision`: an absent key is left alone, an explicit `null` clears the
 * column, a stale revision is a 409. A `SOLD` vehicle refuses every change — phase 6's `vehicles.correct`
 * is the only way one is ever touched again (plan §5.6).
 */
export const updateVehicleContract = oc
    .route({
    method: 'PATCH',
    path: '/vehicles/{vehicleId}',
    tags: ['Vehicles'],
    summary: 'Update an open stock vehicle',
})
    .input(updateVehicleInputSchema)
    .output(vehicleDetailSchema);
//# sourceMappingURL=update-vehicle.contract.js.map